var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 店舖已選擇, 請關閉此頁"),_c('br'),_vm._v(" "+_vm._s(_vm.$route.query)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }